import { render, staticRenderFns } from "./provisionModeList.vue?vue&type=template&id=d896196e&scoped=true"
import script from "./provisionModeList.vue?vue&type=script&lang=js"
export * from "./provisionModeList.vue?vue&type=script&lang=js"
import style0 from "./provisionModeList.vue?vue&type=style&index=0&id=d896196e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d896196e",
  null
  
)

export default component.exports